import { render } from "./GroupSettings.vue?vue&type=template&id=5a76c14d"
import script from "./GroupSettings.vue?vue&type=script&lang=js"
export * from "./GroupSettings.vue?vue&type=script&lang=js"
script.render = render

export default script